module.exports = __webpack_public_path__ + "assets/img/12-m.c549da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/12-m.jpg
// module id = u7iv
// module chunks = 0